import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment, isODM} from '../../environments/environment';

export const STORE_KEY_SummaryEvent = 'event';
export const STORE_KEY_SummaryStatus = 'status';
export const STORE_KEY_SummaryStartDate = 'startDate';
export const STORE_KEY_SummaryEndDate = 'endDate';

@Injectable({
  providedIn: 'root'
})
export class SummaryService {

  event: number;
  status: number;
  startDate: number;
  endDate: number;
  constructor(private http: HttpClient) { }

  ReadEventSummary(params): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/events/read/summary`, params);
  }

  getSummaryDetail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/events/summary/detail`, params);
  }

  set SetSummaryEvent(value) {
    localStorage.setItem(STORE_KEY_SummaryEvent, value);
    this.event = value;
  }

  get GetSummaryEvent() {
    const value = localStorage.getItem(STORE_KEY_SummaryEvent);
    return value;
  }

  set SetSummaryStatus(value) {
    localStorage.setItem(STORE_KEY_SummaryStatus, value);
    this.status = value;
  }

  get GetSummaryStatus() {
    const value = localStorage.getItem(STORE_KEY_SummaryStatus);
    return value;
  }

  set SetSummaryStartDate(value) {
    localStorage.setItem(STORE_KEY_SummaryStartDate, value);
    this.status = value;
  }

  get GetSummaryStartDate() {
    const value = localStorage.getItem(STORE_KEY_SummaryStartDate);
    return value !== '0' ? Number(value) : 0;
  }

  set SetSummaryEndDate(value) {
    localStorage.setItem(STORE_KEY_SummaryEndDate, value);
    this.status = value;
  }

  get GetSummaryEndtDate() {
    const value = localStorage.getItem(STORE_KEY_SummaryEndDate);
    return value !== '0' ? Number(value) : 0;
  }
}
